import Icon from '../../components/Icon.vue'

Icon.register({"regular/play-circle":{"width":512,"height":512,"paths":[{"d":"M371.7 238L195.7 131C179.9 122.2 160 133.5 160 152V360C160 378.4 179.8 389.8 195.7 381L371.7 280C388.1 270.9 388.1 247.2 371.7 238zM504 256C504 119 393 8 256 8S8 119 8 256 119 504 256 504 504 393 504 256zM56 256C56 145.5 145.5 56 256 56S456 145.5 456 256 366.5 456 256 456 56 366.5 56 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/play-circle.js
// module id = null
// module chunks = 